import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Img } from 'react-image';

const Container = styled.div`
  display: flex;
  height: 100px;
  width: 418px;
`;

const Image = styled(Img)`
  width: 100px;
  height: 100px;
  border-radius: 5px;
  box-shadow: 0 3px 20px ${props => props.theme.secondaryColor30Transparent};
`;

const Section = styled.div`
  margin: 0 56px 0 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Text = styled.span`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 17px;
  line-height: 17px;
  text-transform: uppercase;
`;

const Name = styled(Text)`
  color: ${props => props.theme.bodyColor};
`;

const Company = styled(Text)`
  margin-top: 7px;
  color: ${props => props.theme.secondaryColor};
`;

const Profile = ({
  avatar, name, company, url,
}) => (
  <a href={url}>
    <Container>
      <Image src={avatar} />
      <Section>
        <Name>{name}</Name>
        <Company>{company}</Company>
      </Section>
    </Container>
  </a>
);

Profile.propTypes = {
  avatar: PropTypes.string,
  name: PropTypes.string.isRequired,
  company: PropTypes.string,
  url: PropTypes.string.isRequired,
};

Profile.defaultProps = {
  avatar: null,
  company: null,
};

export default Profile;
